import SwitchComponent from './containers/switchComponent'

export { default as SwitchLayout } from './components/switchLayout' 

export default SwitchComponent